import React, { useEffect, useState } from "react";
import { Button, Col, Container, Row, Form, Spinner } from "react-bootstrap";
import axios from "axios";
import moment from "moment";
import TableComponent from "../Table/Table";
import Select from 'react-select'
import { useSelector } from 'react-redux';
import ReactExport from "react-data-export";
import { CSVLink, CSVDownload } from "react-csv";
function Download(props) {

  const ExcelFile = ReactExport.ExcelFile;
  const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
  const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;


  return (
    <>
      {
        props.dataType == 0 ? (
          <ExcelFile hideElement={true} filename="Data" fileExtension={props.dataType == 0 ? "xlsx" : "csv"}>
            <ExcelSheet data={props.data} name="Data">
              {
                props.scolumns.filter(d => {
                  return d.active == true
                }).map(column => {
                  return (
                    <ExcelColumn label={column.name} value={column.key} />
                  )
                })
              }
            </ExcelSheet>
          </ExcelFile>
        ) : (
          <>
            <CSVDownload data={props.csvdata} target="_blank" />;
          </>
        )
      }
    </>
  );
}
function UserReport() {
  const [playerReport, setPlayerReport] = useState([])
  const [playerReportFilter, setPlayerReportFilter] = useState({
    period: [],
    filters: {
      playerid: "",
      country: "",
      mediaid: "",
      websiteid: "",
      affiliateid: "",
      affiliategroup: "",
      commissiongroup: ""
    }
  })
  const [ltCount, setLtCount] = useState([])
  const [ltComGrp, setLtComGrp] = useState([])
  const [ltAffGrp, setLtAffGrp] = useState([])
  const [currentPage, setCurrentPage] = useState(1)
  const [playerPages, setPlayerPages] = useState(1);
  const [loadingPlayerReport, setLoadingPlayerReport] = useState(false)
  const [dateTimeRange, setDateTimeRange] = useState({
    startDate: '',
    endDate: ''
  });
  const [isCustom, setIsCustom] = useState(false);
  const [affliate, setAffliate] = useState({});
  const StoreUser = useSelector((state) => state.user);
  const [depositCount, setDepositCount] = useState(false)
  const [ExportColumns, setExportColumns] = useState([
    {
      Header: "Affiliate ID",
      accessor: "affiliateid",
    },
    {
      Header: "Website ID",
      accessor: "websiteid",
    },
    {
      Header: "Media Id",
      accessor: "mediaid",
    },
    {
      Header: "Website",
      accessor: "website",
    },
    {
      Header: "SubId",
      accessor: "subid",
    },
    {
      Header: "Username",
      accessor: "username",
    },
    {
      Header: "Player Id",
      accessor: "playerid",
    },
    {
      Header: "Registartion Date",
      accessor: "registrationdate",
    },
    {
      Header: "Country",
      accessor: "country",
    },
    ...(depositCount
      ? [
        {
          Header: "Sum Deposits",
          accessor: "sumdeposits",
        },
      ]
      : []),
    {
      Header: "Platform Fees",
      accessor: "PlatformFees",
    },
    {
      Header: "PSP Fees",
      accessor: "PSPFees",
    },
    {
      Header: "Company Profit",
      accessor: "companyprofit",
    }
  ])
  const [csvdata, setCsvData] = useState([]);
  const [extype, setExtype] = useState("");
  const [downloadable, setDownloadable] = useState(false);
  const [loading, setLoading] = useState(false)
  const [columns, setColumns] = useState([]);

  useEffect(() => {
    setDepositCount(checkPermission(affliate, "playerrep_deposits_count"));

    setColumns([
      {
        Header: "Affiliate ID",
        accessor: "affiliateid",
      },
      {
        Header: "Website ID",
        accessor: "websiteid",
      },
      {
        Header: "Media Id",
        accessor: "mediaid",
      },
      {
        Header: "Website",
        accessor: "website",
      },
      {
        Header: "SubId",
        accessor: "subid",
      },
      {
        Header: "Username",
        accessor: "username",
      },
      {
        Header: "Player Id",
        accessor: "playerid",
      },
      {
        Header: "Registartion Date",
        accessor: "registrationdate",
      },
      {
        Header: "Country",
        accessor: "country",
      },
      ...(depositCount
        ? [
          {
            Header: "Sum Deposits",
            accessor: "sumdeposits",
          },
        ]
        : []),
      {
        Header: "Platform Fees",
        accessor: "PlatformFees",
      },
      {
        Header: "PSP Fees",
        accessor: "PSPFees",
      },
      {
        Header: "Company Profit",
        accessor: "companyprofit",
      }
    ])
  }, [affliate])
  useEffect(() => {
    if (StoreUser != undefined) {
      setAffliate(StoreUser.User)
    }
  }, [affliate])
  const checkPermission = (user, permission) => {
    var Permissions = user.Permissions;
    if (Permissions && Permissions.length > 0) {
      const index = Permissions.findIndex(per => per === permission)
      if (index != -1) return true;
      else return false;
    }
    return true
  }
  const getPlayerReport = async () => {
    setLoadingPlayerReport(true)
    const response = await axios.post(window.__CFG.API + "reports/GetPlayersReport?page=" + currentPage, playerReportFilter, {
      headers: {
        "Authorization": "Bearer " + localStorage.getItem("raff-token")
      }
    })
    setLoadingPlayerReport(false)
    if (response.data.Error == null) {
      setPlayerReport(response.data.Result);
      setPlayerPages(response.data.Pages)
    }
    else {
      setPlayerReport([]);

    }
  }
  const handlePageChange = (page) => {
    setCurrentPage(page);
  };
  useEffect(() => {
    getPlayerReport()
  }, [currentPage])
  useEffect(() => {
    var period = []
    if (dateTimeRange.startDate != "" && dateTimeRange.endDate != "") {
      period.push(moment(dateTimeRange.startDate).startOf("day").format("YYYY-MM-DD HH:mm:ss"))
      period.push(moment(dateTimeRange.endDate).endOf("day").format("YYYY-MM-DD HH:mm:ss"))
    }
    setPlayerReportFilter({ ...playerReportFilter, period: period })
  }, [dateTimeRange])
  const formatDate = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };

  const handleSelectPeriodChange = (e) => {
    const selectedValue = e.value;
    const today = new Date();
    let startDate = '';
    let endDate = '';
    setIsCustom(false); // Disable inputs by default

    switch (selectedValue) {
      case 'today':
        startDate = formatDate(new Date(today.setHours(0, 0, 0, 0)));
        endDate = formatDate(new Date(today.setHours(23, 59, 59, 999)));
        break;
      case 'yesterday':
        const yesterday = new Date(today.setDate(today.getDate() - 1));
        startDate = formatDate(new Date(yesterday.setHours(0, 0, 0, 0)));
        endDate = formatDate(new Date(yesterday.setHours(23, 59, 59, 999)));
        break;
      case 'currentmonth':
        startDate = formatDate(new Date(today.getFullYear(), today.getMonth(), 1));
        endDate = formatDate(today);
        break;
      case 'lastmonth':
        startDate = formatDate(new Date(today.getFullYear(), today.getMonth() - 1, 1));
        endDate = formatDate(new Date(today.getFullYear(), today.getMonth(), 0));
        break;
      case 'currentyear':
        startDate = formatDate(new Date(today.getFullYear(), 0, 1));
        endDate = formatDate(today);
        break;
      case 'lastyear':
        startDate = formatDate(new Date(today.getFullYear() - 1, 0, 1));
        endDate = formatDate(new Date(today.getFullYear() - 1, 11, 31));
        break;
      case 'custom':
        setIsCustom(true); // Enable inputs for custom range
        startDate = '';
        endDate = '';
        break;
      default:
        startDate = '';
        endDate = '';
    }
    setDateTimeRange({ startDate, endDate });

  }
  const setTodayAsDefault = () => {
    const today = new Date();
    const startDate = formatDate(new Date(today.setHours(0, 0, 0, 0)));
    const endDate = formatDate(new Date(today.setHours(23, 59, 59, 999)));
    setDateTimeRange({ startDate, endDate });
  };

  useEffect(() => {
    setTodayAsDefault();
  }, []);
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setDateTimeRange((prev) => ({
      ...prev,
      [name]: value
    }));
  };
  const getListAffliateGrp = async () => {
    const response = await axios.get(window.__CFG.API + "manager/ListAllAffiliateGroups", {
      headers: {
        "Authorization": "Bearer " + localStorage.getItem("raff-token")
      }
    })
    if (response.data.Error === null) {
      setLtAffGrp(response.data.Result)
    }
  }
  const getListCommissionGrp = async () => {
    const response = await axios.get(window.__CFG.API + "manager/ListAllCommissionGroups", {
      headers: {
        "Authorization": "Bearer " + localStorage.getItem("raff-token")
      }
    })
    if (response.data.Error === null) {
      setLtComGrp(response.data.Result)
    }
  }
  const getListCountries = async () => {
    const response = await axios.get(window.__CFG.API + "manager/ListAllCountries", {
      headers: {
        "Authorization": "Bearer " + localStorage.getItem("raff-token")
      }
    })
    if (response.data.Error === null) {
      setLtCount(response.data.Result)
    }
  }
  useEffect(() => { getListAffliateGrp(); getListCommissionGrp(); getListCountries() }, [])
  const optionsCurrency = [{ label: "USD", value: 1 }]
  const optionsPeriods = [{ label: "Today", value: "today" }, { label: "Yesterday", value: "yesterday" }, { label: "Current month", value: "currentmonth" }, { label: "Last month", value: "lastmonth" }, { label: "Current year", value: "currentyear" }, { label: "Last year", value: "lastyear" }, { label: "Custom", value: "custom" },]
  const selectedCurrencyValue = optionsCurrency.find(option => option.value === 1)
  const optionsExport = [{ label: "CSV", value: 1 }]
  const selectedExportValue = optionsExport.find(options => options.value === 1)
  const selectKeys = (arr, keys) => {
    return arr.map(item =>
      keys.reduce((acc, key) => {
        if (item.hasOwnProperty(key)) {
          acc[key] = item[key];
        }
        return acc;
      }, {})
    );
  };
  const ExportData = async (type) => {
    setLoading(true);

    const response = await axios.post(window.__CFG.API + "reports/GetPlayersReport?all=true", playerReportFilter, {
      headers: {
        "Authorization": "Bearer " + localStorage.getItem("raff-token")
      }
    });

    setLoading(false);

    setExtype(type)

    if (response.data.Error == null) {
      let mcolumns = [];

      for (var k = 0; k < ExportColumns.length; k++) {
        var column = ExportColumns[k];

        mcolumns.push(column.accessor)

      }

      setCsvData(selectKeys(response.data.Result, mcolumns))

      setDownloadable(true);

      setTimeout(() => {
        setDownloadable(false);
      }, 500)
    }
  }
  return (
    <Container>
      <Row>
        <Col>
          <h4 className="text-start mt-5">Players Report</h4>

          <Row className="justify-content-between  mt-4 me-auto w-100" style={{ paddingBottom: 10 }}>
            <Col lg={6} md={4} sm={4}>
              <div className="form-cre-grp-fl-wp">
                <div className="form-cre-grp-fl-wp-lb">
                  <label>Period</label>
                </div>
                <div className="form-cre-grp-fl-wp-in">
                  <Select options={optionsPeriods} onChange={handleSelectPeriodChange} defaultValue={{ label: "Today", value: "today" }} />

                </div>
              </div>
            </Col>
            <Col lg={6} md={4} sm={5}>
              <div className="form-cre-grp-fl-wp">
                <div className="form-cre-grp-fl-wp-lb">
                  <label>Exact day</label>
                </div>

                <div className="form-cre-grp-fl-wp-in in-rp">
                  <input
                    type="date"
                    name="startDate"
                    style={{ padding: 2, marginRight: 5 }}
                    value={dateTimeRange.startDate}
                    onChange={handleInputChange}
                    disabled={!isCustom}
                  />
                </div>
                <div className="form-cre-grp-fl-wp-in in-rp">
                  <input
                    type="date"
                    name="endDate"
                    style={{ padding: 2, marginRight: 5 }}
                    value={dateTimeRange.endDate}
                    onChange={handleInputChange}
                    disabled={!isCustom}
                  />
                </div>
              </div>
            </Col>
          </Row>

          <Row className="justify-content-between  mt-2 me-auto w-100">
            <Col lg={6} md={4} sm={4}>
              <div className="form-cre-grp-fl-wp">
                <div className="form-cre-grp-fl-wp-lb">
                  <label> Currency </label>
                </div>
                <div className="form-cre-grp-fl-wp-in">

                  <Select options={optionsCurrency} value={selectedCurrencyValue} />

                </div>
              </div>
            </Col>

            <Col lg={6} md={4} sm={5}>
              <div className="form-cre-grp-fl-wp">
                <div className="form-cre-grp-fl-wp-lb">
                  <label>Player id </label>
                </div>
                <div className="form-cre-grp-fl-wp-in">
                  <Form.Control style={{ borderRadius: 3, borderColor: "rgba(0,0,0,0.2)" }} type="text" value={playerReportFilter.filters.playerid} onChange={e => { setPlayerReportFilter(prevstat => ({ ...prevstat, filters: { ...prevstat.filters, playerid: e.target.value } })) }} />
                </div>
              </div>
            </Col>
          </Row>

          <Row className="justify-content-between  mt-2 me-auto w-100">
            <Col lg={6} md={4} sm={4}>
              <div className="form-cre-grp-fl-wp">
                <div className="form-cre-grp-fl-wp-lb">
                  <label> Commission group </label>
                </div>
                <div className="form-cre-grp-fl-wp-in">

                  <Select options={ltComGrp} onChange={e => { setPlayerReportFilter(prevstat => ({ ...prevstat, filters: { ...prevstat.filters, commissiongroup: e.value } })) }} />

                </div>
              </div>
            </Col>

            <Col lg={6} md={4} sm={5}>
              <div className="form-cre-grp-fl-wp">
                <div className="form-cre-grp-fl-wp-lb">
                  <label>website iD </label>
                </div>
                <div className="form-cre-grp-fl-wp-in">
                  <Form.Control style={{ borderRadius: 3, borderColor: "rgba(0,0,0,0.2)" }} type="text" value={playerReportFilter.filters.websiteid} onChange={e => { setPlayerReportFilter(prevstat => ({ ...prevstat, filters: { ...prevstat.filters, websiteid: e.target.value } })) }} />
                </div>
              </div>
            </Col>
          </Row>



          <Row className="justify-content-between  mt-2 me-auto w-100">
            <Col lg={6} md={4} sm={5}>
              <div className="form-cre-grp-fl-wp">
                <div className="form-cre-grp-fl-wp-lb">
                  <label>affiliate group </label>
                </div>
                <div className="form-cre-grp-fl-wp-in">
                  <Select options={ltAffGrp} onChange={e => { setPlayerReportFilter(prevstat => ({ ...prevstat, filters: { ...prevstat.filters, affiliategroup: e.value } })) }} />
                </div>
              </div>
            </Col>
            <Col lg={6} md={4} sm={5}>
              <div className="form-cre-grp-fl-wp">
                <div className="form-cre-grp-fl-wp-lb">
                  <label>media ID </label>
                </div>
                <div className="form-cre-grp-fl-wp-in">
                  <Form.Control style={{ borderRadius: 3, borderColor: "rgba(0,0,0,0.2)" }} type="text" value={playerReportFilter.filters.mediaid} onChange={e => { setPlayerReportFilter(prevstat => ({ ...prevstat, filters: { ...prevstat.filters, mediaid: e.target.value } })) }} />
                </div>
              </div>
            </Col>
          </Row>




          <Row className="justify-content-between  mt-2 me-auto w-100">
            <Col lg={6} md={4} sm={5}>
              <div className="form-cre-grp-fl-wp">
                <div className="form-cre-grp-fl-wp-lb">
                  <label>Affiliate ID </label>
                </div>
                <div className="form-cre-grp-fl-wp-in">
                  <Form.Control style={{ borderRadius: 3, borderColor: "rgba(0,0,0,0.2)" }} type="text" value={playerReportFilter.filters.affiliateid} onChange={e => { setPlayerReportFilter(prevstat => ({ ...prevstat, filters: { ...prevstat.filters, affiliateid: e.target.value } })) }} />
                </div>
              </div>
            </Col>
            <Col lg={6} md={4} sm={4}>
              <div className="form-cre-grp-fl-wp">
                <div className="form-cre-grp-fl-wp-lb">
                  <label>Country </label>
                </div>
                <div className="form-cre-grp-fl-wp-in">
                  <Select options={ltCount} onChange={e => { setPlayerReportFilter(prevstat => ({ ...prevstat, filters: { ...prevstat.filters, country: e.value } })) }} />
                </div>
              </div>
            </Col>
          </Row>

          <Row className="justify-content-between  mt-2 me-auto w-100">
            <Col lg={6} md={4} sm={5}>
              <div className="form-cre-grp-fl-wp">
                <div className="form-cre-grp-fl-wp-lb">
                  <label>sub ID </label>
                </div>
                <div className="form-cre-grp-fl-wp-in">
                  <Form.Control style={{ borderRadius: 3, borderColor: "rgba(0,0,0,0.2)" }} type="text" />
                </div>
              </div>
            </Col>
            <Col lg={6} md={4} sm={4}>
              <div className="form-cre-grp-fl-wp">
                <div className="form-cre-grp-fl-wp-lb">
                  <label>refID </label>
                </div>
                <div className="form-cre-grp-fl-wp-in">
                  <Form.Control style={{ borderRadius: 3, borderColor: "rgba(0,0,0,0.2)" }} type="text" />
                </div>
              </div>
            </Col>
          </Row>

          <Row className="justify-content-between  mt-2 me-auto w-100">
            <Col lg={6} md={4} sm={5}>

            </Col>
            <Col lg={6} md={4} sm={4} className=" pt-2 md-se-btn">
              <div className="form-cre-grp-fl-wp">
                <div className="form-cre-grp-fl-wp-lb">
                </div>
                <div className="form-cre-grp-fl-wp-in md-se-btn">
                  <Button disabled={loadingPlayerReport} onClick={getPlayerReport} className="w-100 bg-warning border-0 rounded-0 btn-height text-dark btn-com-grp">
                    {loadingPlayerReport ? (<> <Spinner size="sm"></Spinner></>) : (<>
                      Generate report
                    </>)}
                  </Button>
                </div>
              </div>
            </Col>
          </Row>
          <div
            style={{
              borderBottom: "1px dashed black",
              marginTop: "20px",
              width: "100%",
            }}
          ></div>
          <Row className="mt-4 me-4 w-100">
            <div className='export-aff'>
              <div style={{ flex: 1 }} className="dashboard-select-periode">
                <Select options={optionsExport} placeholder="export type" value={selectedExportValue} />
              </div>
              <div style={{ marginLeft: 10 }} className='aff-exp-btn'>
                <button disabled={loading} onClick={() => ExportData(1)}>
                  {!loading ? (<>Export</>) : (<><Spinner size="sm"></Spinner> </>)}
                </button>
              </div>
            </div>
          </Row>
          <Row className="mt-2 mb-4">
            <div className="aff-dash-summary-table">

              <TableComponent columns={columns} data={playerReport} Pages={playerPages} currentPage={currentPage} onPageChange={handlePageChange} loading={loadingPlayerReport} />
            </div>
          </Row>


          <Row className="justify-content-start  mt-4  w-100 mb-4">
            <div className="player-report-btns">
            </div>
          </Row>

          {
            downloadable ? (
              <Download scolumns={ExportColumns} dataType={extype} csvdata={csvdata} data={playerReport} />
            ) : (
              <></>
            )
          }
        </Col>
      </Row>
    </Container>
  );
}

export default UserReport;
















